<template>
  <main :class="['content', { 'pt-30 pb-50': !isMobile || isNotOrderDetails }]" style="min-height: 500px;">
    <div :class="{ 'container': !isMobile || isNotOrderDetails }">
      <transition name="component-fade" mode="out-in">
        <router-view />
      </transition>
    </div>
    <CancelOrderSuccess />
  </main>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import $ from "jquery";

import CancelOrderSuccess from "@/components/orders/CancelOrderSuccess";

export default {
  components: {
    CancelOrderSuccess
  },
  computed: {
    ...mapState("merchant", {
      customerPortalToken: state => state.customerPortalToken,
      merchantSettings: state => state.settings.login,
      subdomain: state => state.subdomain,
      merchantIsLoading: state => state.loading,
      merchantErrors: state => state.errors
    }),
    isNotOrderDetails () {
      const path = this.$route.path.split('/').pop();
      return path  === 'upcoming' || path === 'past';
    },
    ...mapGetters({
      isMobile: "isMobile/isMobile"
    })
  },
  mounted () {
    $("body").css({ backgroundColor: "#f4f5f8" });
  }
};
</script>

<style lang="scss" scoped>
@import "./../../assets/styles/views/orders/_base.scss";
</style>
